(() => {
  'use strict';
  const header = document.getElementById('library-header');
  if (!header || document.body.classList.contains('home-page')) return;

  // 10/17 Josh: "redo the headers to match the hero… i mostly want the fall icons and maine ones so we can swap out
  // seasonally". Every inner band is a small copy of the home hero: the wordmark on its white plate, the hero's chrome
  // VP on the left and gold VP on the right, and the rest from two pools of Yuliia's art: this SEASON's icons and the
  // MAINE icons (all year). One frame (FRAME below) holds every slot on every page; pages differ only in which pool
  // items fill the slots. (Replaces the 10/16 four-animal mix.)
  // SEASON SWAP: change SEASON below. Any page previews another season with ?season=winter. The home hero's fall
  // wings (turkey, corn, pumpkin) live in home-collage.js LAYOUT and swap on their own.
  const SEASON = 'fall';
  // Shapes: tall art only goes in tall slots, wide in wide, square in square, so every slot reads the same size
  // whatever fills it. A new season needs the same shapes (2 tall, 2 wide, 1 square).
  const POOLS = {
    fall: { tall: ['corn', 'mushroom'], wide: ['pumpkin', 'turkey'], square: ['leaves'] },
    winter: { tall: ['snow-flower', 'moon'], wide: ['penguin', 'sun-moon'], square: ['snowflake'] },
    maine: { tall: ['lighthouse', 'lobster', 'pinetree'], wide: ['loon', 'mountain', 'seagull'] }
  };
  const VP = {
    chrome: [(window.VP_CDN+"home-refinement__header-chrome-front.webp?v=44f9f22e07"), 1632, 1210],
    gold: [(window.VP_CDN+"home-refinement__header-gold-front.webp?v=0f1cc0d5ce"), 1632, 1210]
  };
  const SIZES = {
    pumpkin: [720, 596], corn: [629, 896], turkey: [896, 745], leaves: [888, 900], mushroom: [695, 900],
    lighthouse: [544, 720], lobster: [526, 720], pinetree: [345, 720], loon: [720, 474], mountain: [720, 492],
    seagull: [720, 591], snowflake: [896, 895], penguin: [896, 532], 'snow-flower': [701, 892], moon: [627, 896],
    'sun-moon': [896, 782]
  };
  // [slot, pool, shape (or the VP), desktop [x, y, w, h, angle, z] | null, phone [...] | null]
  // x/y = frame px from the band centre, w x h = the box the art is fitted inside (it never grows past it).
  // Desktop frame 1440 x 180, phone 440 x 140; header-v13.css scales the frame as one picture to every window.
  // Layout = GPT's art direction (10/17): four per side, two fall + two Maine each, VPs on the outer top corners like the
  // hero; phone keeps the corner VPs, a tall sticker under each and two small accents above and below the plate.
  // 10/17 Josh (black title bar back): "make sure they don't overlap the black bar as much as before": the two low wide
  // slots (f3, m2) moved up and ~6% smaller, so art hangs a few px onto the bar at most (was up to 22 px).
  const FRAME = [
    ['vp-l', 'vp', 'chrome', [-635, -28, 136, 102, -6, 5], [-177, -39, 64, 48, -8, 5]],
    ['vp-r', 'vp', 'gold', [635, -28, 136, 102, 6, 5], [177, -39, 64, 48, 8, 5]],
    ['f1', 'season', 'tall', [-493, 25, 90, 132, -5, 4], [-175, 37, 50, 70, -5, 4]],
    ['f2', 'season', 'square', [-353, -32, 98, 98, -8, 3], null],
    ['f3', 'season', 'wide', [357, 50, 118, 78, -6, 4], [-51, -53, 54, 28, -3, 4]],
    ['m1', 'maine', 'tall', [493, 25, 90, 132, 5, 4], [175, 37, 50, 70, 5, 4]],
    ['m2', 'maine', 'wide', [-357, 60, 112, 60, -5, 3], [52, 55, 58, 30, 5, 3]],
    ['m3', 'maine', 'wide', [353, -40, 126, 76, 7, 3], null]
  ];
  // Which pool item each slot takes on page i (nav order): neighbouring pages always differ, no art repeats on a
  // page, and every item shows somewhere on the site (GPT's rotation, 10/17).
  const PICK = {
    f1: i => i, f2: () => 0, f3: i => i + (i >> 1), m1: i => i,
    m2: i => i + Math.floor(i / 3), m3: i => i + Math.floor(i / 3) + 1 + Math.floor(i / 3) % 2
  };
  // Accent stars like the hero's: [desktop [x, y, size] | null, phone [...] | null, soft grey?]
  // Sizes match the hero's stars at this band's scale (GPT's spots).
  const SPARKS = [
    [[-270, -59, 19], [-66, 56, 11], false],
    [[270, 63, 21], [75, -53, 12], true],
    [[60, -78, 14], null, false]
  ];
  // Never two look-alikes on one page (Josh 10/08: "the double bird looking the same isn't working"). GPT caught winter
  // labels putting the loon over the penguin; a clash moves the later slot on to the next item of its pool.
  const LOOKALIKES = [['loon', 'penguin']];
  const alike = (a, b) => a === b || LOOKALIKES.some(pair => pair.includes(a) && pair.includes(b));
  // Nav order: each page's place shifts the pools by one, so neighbouring pages never show the same picks.
  const NAV = ['custom-stickers', 'specialty-stickers', 'embossed-stickers', 'labels', 'jar-labels', 'configurator',
    'packaging', 'jars', 'posters', 'design', 'about', 'contact', 'bulk-order', 'help', 'returns'];
  const page = window.VP_PAGE || location.pathname.split('/').filter(Boolean).pop()?.replace(/\.html$/, '');
  const asked = new URLSearchParams(location.search).get('season');
  const season = asked && asked !== 'maine' && POOLS[asked] ? asked : SEASON;
  const turn = Math.max(0, NAV.indexOf(page));

  const artwork = header.querySelector('.library-artwork');
  if (artwork) {
    header.dataset.season = season;
    artwork.querySelectorAll('.library-sticker,.library-spark').forEach(element => element.remove());
    const fragment = document.createDocumentFragment();
    const shown = [];
    FRAME.forEach(([slot, pool, shape, desk, phone], index) => {
      let src, width, height, art = shape;
      if (pool === 'vp') [src, width, height] = VP[shape];
      else {
        const list = POOLS[pool === 'season' ? season : pool][shape];
        let name = list[PICK[slot](turn) % list.length];
        for (let step = 1; step < list.length && shown.some(other => alike(name, other)); step++) name = list[(PICK[slot](turn) + step) % list.length];
        shown.push(name);
        art = name;
        src = (window.VP_CDN+"vp-stickers__") + name + '.webp';
        [width, height] = SIZES[name];
      }
      const sticker = document.createElement('div');
      sticker.className = 'library-sticker vp-slot' + (desk ? '' : ' vp-slot-phone') + (phone ? '' : ' vp-slot-desk');
      sticker.dataset.slot = slot;
      sticker.dataset.art = src.split('/').pop().replace('.webp', '');
      [['d', desk], ['p', phone]].forEach(([prefix, spot]) => {
        if (!spot) return;
        ['x', 'y', 'w', 'h'].forEach((axis, i) => sticker.style.setProperty(`--${prefix}${axis}`, spot[i]));
        sticker.style.setProperty(`--${prefix}a`, spot[4] + 'deg');
        sticker.style.setProperty(`--${prefix}z`, spot[5]);
      });
      // Scroll drift pushes each sticker out from the wordmark (header-v13.js).
      const [x, y] = desk || phone;
      sticker.dataset.driftX = Math.round(x / 7);
      sticker.dataset.driftY = Math.round(y / 2);
      sticker.dataset.turn = (index % 2 ? 1 : -1) * (12 + index % 4 * 4);
      sticker.style.setProperty('--float-period', (7 + (index * 7) % 4) + 's');
      sticker.style.setProperty('--float-delay', -((index * 1.7) % 8).toFixed(1) + 's');
      const image = new Image(width, height);
      image.alt = '';
      image.decoding = 'async';
      image.draggable = false;
      // Band-sized copy (tools/header-art/build_hdr.py); the full art only loads if a copy is missing.
      image.dataset.src = (window.VP_CDN+"vp-stickers__hdr__") + art + '.webp';
      image.dataset.full = src;
      sticker.append(image);
      fragment.append(sticker);
    });
    SPARKS.forEach(([desk, phone, soft]) => {
      const spark = document.createElement('span');
      spark.className = 'library-spark vp-spark' + (soft ? ' is-soft' : '') + (desk ? '' : ' vp-slot-phone') + (phone ? '' : ' vp-slot-desk');
      spark.textContent = '✦';
      [['d', desk], ['p', phone]].forEach(([prefix, spot]) => spot && ['x', 'y', 's'].forEach((axis, i) => spark.style.setProperty(`--${prefix}${axis}`, spot[i])));
      fragment.append(spark);
    });
    artwork.append(fragment);
  }

  // Only art the active layout shows is fetched; phone-only or desktop-only art loads if the window crosses over.
  // 10/17 Josh: stickers "sometimes just load as black bounding boxes for a moment before they load in". Safari can
  // paint a half-downloaded image without its alpha, so each sticker stays hidden (header-v13.css) until its art is
  // fully loaded and decoded, then fades in.
  const loadVisibleArt = () => {
    header.querySelectorAll('.library-sticker img[data-src]').forEach(image => {
      if (getComputedStyle(image.parentElement).display === 'none') return;
      image.addEventListener('load', () => image.decode().catch(() => {}).then(() => image.classList.add('is-ready')));
      image.addEventListener('error', () => {
        const full = image.dataset.full;
        image.removeAttribute('data-full');
        if (full) image.src = full;
      });
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    });
  };
  loadVisibleArt();
  matchMedia('(max-width: 720px)').addEventListener('change', loadVisibleArt);
})();
